module.exports = __webpack_public_path__ + "img/bg1_ekb.e2dd6302.jpg";